import { CONST_VALUES, PageNames } from './constValues';
import { clientConfig } from './configService';

export default class Helper {

    static setPagePath(pathname: string): void {
        sessionStorage.setItem(CONST_VALUES.PAGE, pathname);
    }

    static getPagePath(): string {
        return sessionStorage.getItem(CONST_VALUES.PAGE) ?? "/";
    }

    static formatAsPhone(phoneNumber: string): string {
        var cleaned = ('' + phoneNumber).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return phoneNumber;
    }

    static formatAsDateTime = (dateToFormat: Date) => {
        if (dateToFormat) {
            var newDate = new Date(dateToFormat + 'Z');
            const longEnUSFormatter = new Intl.DateTimeFormat('en-US', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
            var dateString = longEnUSFormatter.format(newDate);
            var timeString = newDate.toLocaleTimeString("en-US", {
                hour: 'numeric',
                minute: '2-digit'
            });
            return dateString + ' ' + timeString.toLowerCase();
        }
        else {
            return 'Unknown';
        }
    }

    static formatAsShortDateTime = (dateToFormat: Date) => {
        var newDate = new Date(dateToFormat + 'Z');

        const dateFormatted = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(newDate);


        var timeString = newDate.toLocaleTimeString("en-US", {
            hour: 'numeric',
            minute: '2-digit'
        });
        return dateFormatted + ' ' + timeString.toLowerCase();
    }

    static formatAsDateOnly = (dateToFormat: Date) => {
        if (dateToFormat) {
            var newDate = new Date(dateToFormat + 'Z');
            const longEnUSFormatter = new Intl.DateTimeFormat('en-US', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
            var dateString = longEnUSFormatter.format(newDate);
            return dateString;
        }
        else {
            return 'Unknown';
        }
    }

    static formatAsDateOnlyWithoutTimeZoneConversion = (dateToFormat: Date) => {
        if (dateToFormat) {
            try {
                var newDate = new Date(dateToFormat);

                const longEnUSFormatter = new Intl.DateTimeFormat('en-US', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                });
                var dateString = longEnUSFormatter.format(newDate);
                return dateString;
            }
            catch {
                return "Unknown";
            }
        }
        else {
            return 'Unknown';
        }
    }
    /**
     * Returns routes that do not require authentication.
     * These are all PageNames that are NOT in the client's REGISTERED_USERS_PAGES config.
     */
    static getNonSecureRoutes = (): string[] => {
        const registeredPages = clientConfig?.CONTENT?.REGISTERED_USERS_PAGES || [];
        const registeredPageNames = registeredPages.map(p => p.PageName.toLowerCase());

        return Object.values(PageNames)
            .filter(page => !registeredPageNames.includes(page.toLowerCase()))
            .map(page => `/${page}`.toLowerCase());
    }

}